import React, { FC } from "react";
import { withTranslation } from "react-i18next";

import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";

import imitBg from "assets/images/imit-bg.png";

type AboutProps = {};

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  heroBg: {
    backgroundSize: "cover",
    backgroundPosition: "center",
    height: "400px",
    width: "100%",
  },
}));

const About: FC<AboutProps> = () => {
  const classes = useStyles();
  console.log("imitBg", imitBg);
  return (
    <Box
      className={classes.heroBg}
      display="flex"
      justifyContent="center"
      style={{ backgroundImage: `url(${imitBg})` }}
    ></Box>
  );
};

export default withTranslation()(About);
